import { Component, OnInit, TemplateRef} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { HttpParams } from "@angular/common/http";
import * as CONSTANT from "../../services/constants"
import swal from "sweetalert2";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Observable, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { UserDetailsService } from "src/app/services/user/user-details.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-job-post",
  templateUrl: "./job-post.component.html",
  styleUrls: ["./job-post.component.css"]
})
export class JobPostComponent implements OnInit {
  allJobs:any=[];
  currentPage=1;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  // sorting
  totalCount: any;
  sortType: any;
  sortBy : string = ""
  orderBy: string = "2";
  search="";
  closeSearch:boolean = false;
  //modal box
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  isStatus;
  //form
  showError:boolean = false;
  jobForm: FormGroup;
  userJobTitleUpdate = new Subject<string>();
  show = true;
  addedJobs:any=[];
  userJobTitle: string = "";
  // permission
  public userPermissionData: any;
  public userDatas: any;
  public addPostCount: any;
  recruiterUserId:any;
  constructor(private modalService: BsModalService,public route: ActivatedRoute, private router: Router,private api: AdminService,private formBuilder: FormBuilder, private userDetailsService: UserDetailsService, private toastrService: ToastrService) { 
    this.jobForm = this.formBuilder.group({
      id:[""],
      reason:["", Validators.compose([Validators.required,Validators.minLength(3),Validators.maxLength(2000)])],
      isBlocked:[""],
      isNotify:[""]
    })
    this.userDetailsService.getRecruiterUserData();
    this.userDetailsService.userDetailsObserver.subscribe(userData => {
      this.userDatas = userData; 
      
    });
    this.userDetailsService.getRecruiterPermission();
    this.userDetailsService.userPermissionObserver.subscribe(res => {
      this.userPermissionData = res; 
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      console.log(params,'params');
      this.recruiterUserId =params['recruiterUserId'] 
      this.currentPage = params['page'];
      if (this.currentPage) {
        this.currentPage = this.currentPage;
        this.pagination.skip = (this.currentPage - 1) * this.pagination.limit;
      } else {
        this.currentPage = 1;
      }
     });
    this.userJobTitleUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        if(value == ""){
          this.allJobs = [];
          this.show=false;
        } else{
          this.search=value
          this.getJobs()
        }
      });
      this.getJobs();
  } 
  getJobs(){
    let params = new HttpParams(); 
    params = params.append("skip", this.currentPage);
    params = params.append("limit", this.pagination.limit.toString());
    if (this.search != null && this.search != "") {
      params = params.append("search", this.search);
    }
    if (this.sortBy) {
      params = params.append(
        "sortBy",
        this.sortBy.trim() ? this.sortBy.trim() : ""
      );
      params = params.append("orderBy", this.orderBy == "ASC" ? "ASC" : "DESC");
    }
    // this.api.stopLoader();
    if(this.recruiterUserId != undefined){ 
      params = params.append("recruiterUserId", this.recruiterUserId);
      this.api.getData(apiUrl._getJobsListingBySubRecruiter,params)
      .subscribe(async (res) => {
        this.pagination.totalItems = res.data.count; 
        this.totalCount = res.data.count; 
        this.allJobs = res.data.listing; 
        this.api.stopLoader();

      })
    } else { 
      this.api.getData(apiUrl._getJobsListing,params)
      .subscribe(async (res) => {
        this.pagination.totalItems = res.data.count; 
        this.totalCount = res.data.count; 
        this.allJobs = res.data.listing; 
        this.api.stopLoader();

      })
    }
  }
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit; 
    window.scroll(0, 0);
    this.getJobs();
  }
  goToDetail(data){
    this.router.navigate(["/jobs/applicant/" + data.id], { queryParams: { page: this.currentPage } })
  }
  goToSuggestedDetail(data){
    this.router.navigate(["/jobs/suggested/" + data.id], { queryParams: { page: this.currentPage } })
  }
  reDirectTo(){
    if(this.userDatas.companyPayment?.jobsCreadits > this.userDatas.companyPayment?.companyPostedJob){
      this.router.navigate(["/jobs/post-job"])
    } else{
      this.toastrService.error("", "Your Add job post count is 0 to see more applicant profile you need to buy the new plan.");
    }
  }
  // search() {
  //   this.userJobTitleUpdate.next(this.userJobTitle)
  // }
  searchFun() {  
    this.userJobTitleUpdate.next(this.userJobTitle)
    this.currentPage = 1;
    this.pagination.skip = 0; 
    this.closeSearch = true;  
    this.getJobs(); 
    }
  clearSearch() {
    this.search= "";
    this.closeSearch = false;
    this.pagination.skip = 0; 
    localStorage.removeItem("type-redirect");
    this.getJobs(); 
  }
  //  sorting
  setOrderBy(column) {
    if( this.sortBy != column){
      this.sortBy = column;
      this.orderBy = "ASC";
    }
    else{
   if( this.orderBy == "ASC"){
      this.orderBy = "DESC";
    }
    else{
      this.orderBy = "ASC";
     }
    } 
    if( this.allJobs.length > 0){
      this.getJobs(); 
    }  
  } 
  // job status
  jobStatus(event,number,id){
    let block;
    let text;
    if(number == 0){
      block = 0;
      text = "<p>Are you sure you want to Open this job?</p>";
    }else{block =1;
      text = "<p>Are you sure you want to Close this job?</p>";
    }
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText:"Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
  }).then((result) => {
    if (result.value) { 
      const data = {
        "id": id, 
        "isBlocked": block, 
        "isConfirm": 1, 
      }
      this.api.putData(apiUrl._getJobs, data).subscribe(res => {
      this.getJobs();
    })
  }
  });
  }
   
  // job close status
  openModal(id,jobCloseStatus: TemplateRef<any>) { 
    this.jobForm.reset()
    this.jobForm.patchValue({
      id:id,
      isBlocked:1,
    })
    this.modalRef = this.modalService.show(
      jobCloseStatus,
      Object.assign({},this.config, { class: "modal-sm addModal" })
    ); 
  }  
  jobPostStatus(){
    if(this.jobForm.valid){
      if(this.jobForm.value.isNotify == true){
        this.jobForm.patchValue({
          isNotify : 1
        })
      } else{
        this.jobForm.patchValue({
          isNotify : 0
        })
      }
      this.api.putData(apiUrl._statusReason, this.jobForm.value).subscribe(res => {
        this.modalRef?.hide()
        this.jobForm.reset()
        this.getJobs(); 
      })  
    } else{
      this.showError= true
      setTimeout(() => {
        this.showError= false
      }, 1500);
    }
  }
  // delete
  deleteStatus(id){
    let text = "<p>Are you sure you want to discard this job?</p>";
      swal.fire({
        html: text,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: "#EF7E2B",
        cancelButtonColor: "#ffffff",
        confirmButtonText:"Yes",
        cancelButtonText: "No",
        reverseButtons: true,
        width: 500
      }).then((result) => {
        if (result.value) { 
          const data = {
            "id": id, 
          }
          this.api.deleteData(apiUrl._deleteJobs, data).subscribe(res => {
          this.getJobs();
          })
        }
      });
  }
}
